import React, { useEffect, useState } from 'react';
import '../../../styles/mainContents.css';
import '../../../styles/mainConsignmentContents.css'
import { setAddConsignmentPopup, fetchConsignmentsProduct, fetchConsignmentsCustomer, fetchUserConsignmentsCustomers, fetchDeleteItemsRow, fetchEditItemsRow, fetchInsertItemsRow } from '../../../redux/actions/consignmentsPostActions';
import { useDispatch, connect } from 'react-redux';
import ErrorHandlerAlert from '../../error/ErrorHandlerAlert';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { JsonWebTokenError } from 'jsonwebtoken';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import EditItemModel from './EditItemModel';
import InsertItemModel from './InsertItemModel';
import ConsignmentHeader from '../../layout/ConsignmentHeader';
import InventoryCount from './InventoryCount';
import FormControl from "@mui/material/FormControl";
import InventoryCountEdit from './InventoryCountEdit';
import InventoryCountReplenish from './InventoryCountReplenish';

function ManageConsignments(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect( () => { 
    fetch_UserConsignmentsCustomers(authreducerState.user.userid);    
  }, []);

  const { set_AddConsignmentPopup, addConsignmentPopup, fetch_ConsignmentsCustomer, authreducerState, fetch_ConsignmentsProduct, fetch_UserConsignmentsCustomers, fetch_deleteItemsRow, fetch_editItemsRow, consignmentsProductState, consignmentsCustState, userConsignmentsCustState } = props;
  // console.log("ManageConsignments() consignmentsCustState: " + JSON.stringify(consignmentsCustState));

  const [ custnoState, setCustnoState ] = useState({
    custnoInput: '',
  });

  const defaultItemModel = {
    showModel: null,
    custnoClicked: null,
    prdidClicked: null,
    partnoClicked: null,
    custClickedDetails: null,
    consignmentClickedDetails: null,
    
  };

  // const [ insertItemModel, setInsertItemModel ] = useState(defaultItemModel);

  const columnsOptions = (colName='', inputType='number',filterEnabled=false) => {
    var options = {}


    colName === '' ? 
      options = {
        filter: filterEnabled,
        onFilterChange: (changedColumn, filterList) => {
          // console.log(changedColumn, filterList);
        },          
        sort: true,
        selectableRows: 'multiple',
        filterType: 'dropdown',
        responsive: 'standard',
      } 
    :
      options = {
        filter: filterEnabled,
        onFilterChange: (changedColumn, filterList) => {
          // console.log(changedColumn, filterList);
        },          
        sort: true,
        selectableRows: 'multiple',
        filterType: 'dropdown',
        responsive: 'standard',
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let newConsignmentsCustState = [...consignmentsCustState]
          let currDateValue = null;
          let today = moment();
          let maxDate = today.format("YYYY-MM-DD");
          let maxValue = 1000;

          if(inputType === 'date'){              
            currDateValue = moment(newConsignmentsCustState[dataIndex][colName], "MM/DD/YYYY").format("YYYY-MM-DD"); //format to HTML5 date format
          }

          return (
            <span>
              {authreducerState.user.role_name === undefined || 
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? ( 
                <React.Fragment></React.Fragment> ) : (
                <React.Fragment>
                  {/* <p id={'iInputIndex' + dataIndex + '-' + rowIndex} contentEditable='true' 
                    style={{background:'lightblue'} }
                  > {consignmentsCustState[dataIndex][colName]}
                  </p> */}
                  

                  {//console.log('1ConsignmentsCustState[dataIndex] '+ JSON.stringify(consignmentsCustState))
                  }
                  
                  <input 
                    id={'iInputIndex' + dataIndex + '-' + rowIndex + '-' + colName} 
                    type={inputType} 
                    name={'nInputIndex' + dataIndex + '-' + rowIndex}
                    //key={inputType === 'date' ? currDateValue : newConsignmentsCustState[dataIndex][colName]}
                    //key={dataIndex + '-' + rowIndex}
                    key={inputType === 'date' ? currDateValue : dataIndex + '-' + rowIndex}
                    defaultValue={inputType === 'date' ? currDateValue : newConsignmentsCustState[dataIndex][colName]}
                    onChange={(e) => {
                        // const row = newConsignmentsCustState[dataIndex]
                        // let tempConsignmentsCustStateRow = [...newConsignmentsCustState]

                        // tempConsignmentsCustStateRow[dataIndex][colName] = e.target.value
                        // newConsignmentsCustState[dataIndex] = {...row, ...tempConsignmentsCustStateRow[dataIndex]}
                        // console.log('e.target.value: ' + e.target.value + ' newConsignmentsCustState['+dataIndex+'] '+ JSON.stringify(newConsignmentsCustState[dataIndex]))

                        //TODO: 220722 FIX SORTING ON DATE FIELDS --> SORTING CHANGES DATE TO NULL
                        newConsignmentsCustState[dataIndex][colName] = e.target.value
                      }
                    }
                    max={inputType === 'date' ? maxDate : maxValue}
                  />                                                                           
                  
                </React.Fragment>
              )}
            </span>             
          )
        }
      }
      return options;
  };

  //NOTE: when editing columns, may need to edit InsertItemsModel.js addConsignmentPopup.consignmentClickedDetails list indexes as well
  const columns = [
    {
      name: "PRDID",
      label: "Prdid",
      options: {
        filter: false,
        display: false, 
      },
      
    },     
    {
      name: "LINE",
      label: "line",
      options: columnsOptions('','string',true),
    },
    {
      name: "PARTNO",
      label: "partno",
      options: columnsOptions(),
    },
    {
      name: "DESCRIPTION",
      label: "description",
      options: columnsOptions(),
    },  
    {
      name: "CONSIGN",
      label: "consign",
      // options: columnsOptions("CONSIGN"),
      options: columnsOptions(),
    },
    {
      name: "CONSIGNED_ON",
      label: "consigned_on",
      // options: columnsOptions("CONSIGNED_ON", 'date'),
      options: columnsOptions(),

    },
    {
      name: "LAST_SALE",
      label: "last_sale",
      // options: columnsOptions("LAST_SALE", 'date'),
      options: columnsOptions(),
    },
    {
      name: "CUR_C4",
      label: "C4",
      options: columnsOptions(),
    },  
    {
      name: "CUR_CORE_COST",
      label: "core cost",
      options: columnsOptions(),
    },
    {
      name: "LAST_EDIT_DATE",
      label: "last edit",
      options: columnsOptions(),
    },  
    // {
    //   name: "CORE_PRICE",
    //   label: "core_price",
    //   options: columnsOptions(),
    // },
    // {
    //   name: "LAST_SALE_PRICE",
    //   label: "last_sale_price",
    //   options: columnsOptions(),
    // },
  ]

  const optionsConsignmentsTbl = {
      filterType: "checkbox",
      // selectableRows: "multiple",
      selectableRows: false,
      rowsPerPage: 200,
      onRowClick: (rowData, rowMeta) => {
        // console.log('optionsConsignmentsTbl', rowData, rowMeta);

        set_AddConsignmentPopup({
          ...addConsignmentPopup,
          showModel: 'edit',
          prdidClicked: rowData[0],
          partnoClicked: rowData[1] + rowData[2],
          consignmentClickedDetails: rowData
        })        
      },

      onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
        const result = rowsSelected.map(item => {
          return consignmentsCustState[item];
        });
        const selectedPrdids = result.map(item => {
          return item.PRDID;
        });

      },
      onRowsDelete: (rows) => {
        var rowItems = {}
        var rowItemsList = []

        rows.data.forEach(i => {
          // console.log( i.dataIndex )

          //prompt to confirm if want to delete after click

          const row = consignmentsCustState[i.dataIndex]

          const selectedConsignmentId = row['CONSIGNMENTID']
          const selectedPrdid = row['PRDID']
          // console.log( 'onRowsDelete: ' + selectedPrdid  );

          // const rowItemsIds = {
          //   consignmentId: selectedConsignmentId,
          //   prdid: selectedPrdid
          // }

          const rowItemsIds = {
            consignmentId: selectedConsignmentId,
            prdid: selectedPrdid
          }
          rowItemsList.push(rowItemsIds)
        })

        if(rowItemsList.length > 0){
          rowItems = {'rowItems': rowItemsList}
          fetch_deleteItemsRow(rowItems);
        }


      }, //<---- e.data is a array of rows
    };


  const addConsignmentsClick = () => {    

    set_AddConsignmentPopup({
      ...addConsignmentPopup,
      showModel: 'insert',
      prdidClicked: null,
      partnoClicked: null,
      consignmentClickedDetails: []
    })   

  };

  const columnsOptions_userConsignmentCust = (colName='', displayType=true, filterEnabled=false) => {
    var options = {};
    options = {
        filter: filterEnabled,
        sort: true,
        display: displayType,
        setCellHeaderProps: value => {
          return {
            style: {
              whiteSpace: "pre-wrap",
              position: "sticky",
              top: '0',
              zIndex: 101,  
            }
          }
        }, 
        setCellProps: () => ({
          style: {
            whiteSpace:'nowrap',
            fontSize: '10px',
          }

        }),   

        //SOMEHOW THIS IS NOT WORKING --- DON'T NEED TO MODIFY COLUMN DATA ATM SO COMMENTED IT OUT
        // customBodyRenderLite: (dataIndex, rowIndex) => {  
        //   console.log('colName',colName,'{userConsignmentsCustState[dataIndex][colName]}  ', userConsignmentsCustState  )

        //   return (
        //     <span>  
        //       <React.Fragment>              
        //         {userConsignmentsCustState[dataIndex][colName]}  
        //       </React.Fragment>                                                                                  
        //     </span>
        //   ) 
        
        // }
    }

    return options;
  }

  const options_userConsignmentCust = {
    //filterType: "checkbox",
    selectableRows: false,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: '400px',
    responsive: 'standard',  
    rowsPerPage: 200,  
    searchAlwaysOpen: true,
    onRowClick: (rowData, rowMeta) => {
      // console.log('options_userConsignmentCust clicked',rowData,'rowData[2]',rowData[2]);

      var custno = rowData[2];


      // SAVE FOR FUTURE IMPLEMENTATION
      // set_AddConsignmentPopup({
      //   ...addConsignmentPopup,
      //   custnoClicked: custno,
      //   custClickedDetails: rowData
      // })

      fetch_ConsignmentsCustomer({custnoInput: custno}, true, false);
    },


  };

  const columns_userConsignmentsCust = [   
    {
      name: "SLSM",
      label: "Slsm",
      options: columnsOptions_userConsignmentCust("SLSM","excluded",false),
    },
    {
      name: "MGR_GROUP",
      label: "Mgr_group",
      options: columnsOptions_userConsignmentCust("MGR_GROUP","excluded",false),
    },    
    {
      name: "CUSTNO",
      label: "Custno",
      options: columnsOptions_userConsignmentCust("CUSTNO",false,true),
    },
    {
      name: "CUSTNAME",
      label: "Custname",
      options: columnsOptions_userConsignmentCust("CUSTNAME","excluded",false),
    },  
    {
      name: "CUST",
      label: "Cust",
      options: columnsOptions_userConsignmentCust("CUST",true,false),
    },       
    {
      name: "ADDR1",
      label: "Addr1",
      options: columnsOptions_userConsignmentCust("","excluded",false),
    },  
    {
      name: "ADDR2",
      label: "Addr2",
      options: columnsOptions_userConsignmentCust("","excluded",false),
    }, 
    {
      name: "CITY",
      label: "City",
      options: columnsOptions_userConsignmentCust("","excluded",false),
    },   
    {
      name: "STATE",
      label: "State",
      options: columnsOptions_userConsignmentCust("","excluded",false),
    },   
    {
      name: "ZIP",
      label: "Zip",
      options: columnsOptions_userConsignmentCust("","excluded",false),
    },   
    {
      name: "CONSIGN_SKU_TOTAL",
      label: "Consign\nSKU Total",
      options: columnsOptions_userConsignmentCust("CONSIGN_SKU_TOTAL",true,false),
    },   
  ]

    // const isMobile = useMediaQuery({ maxWidth: 767 });
    // const isDesktop = useMediaQuery({ minWidth: 768 });
  
  return (

    <div className="ConsignmentsCN">

      <main>

        <div>          
          <div>
            {!authreducerState.isLoggedIn ? (

              <React.Fragment>
                {history.push('/login')}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <ConsignmentHeader />
              </React.Fragment>
            )}

            <div>


                {/* <button onClick={() => {
                    fetch_UserConsignmentsCustomers(authreducerState.user.userid, true);

                    // console.log("ManageConsignments() authreducerState.user.userid: " + JSON.stringify(authreducerState.user) + " btnUserCustConsignmentState: " + btnUserCustConsignmentState);
              
                }}>Load Custno Consignment Items Limited to User Only
                </button>                 */}
            </div>

            {/* <button style={{display:"none"}}
              onClick={ () => {
                fetch_ConsignmentsProduct();
              }}
              > Fetch ConsignmentsProduct Data
            </button> */}



            <InsertItemModel insertItemModel={addConsignmentPopup || defaultItemModel } />  

            <EditItemModel insertItemModel={addConsignmentPopup || defaultItemModel } />  

            <div className='userConsignmentsTblId'>

              { userConsignmentsCustState !== undefined ?
                  userConsignmentsCustState.length > 0 ?
                    <div>   
                      {/* <FormControl></FormControl>                      */}
                      <div className='tableTitleCn'>
                        User Consignment Customers Data
                      </div>

                      <MUIDataTable                          
                          data={userConsignmentsCustState}
                          columns={columns_userConsignmentsCust}
                          options={options_userConsignmentCust}
                      />
                    </div>

                      : ''
                  : 'userConsignmentsCustState undefined'
              }
            </div>

            <div id='consignmentsTblId'>

              { consignmentsCustState !== undefined ?
                  consignmentsCustState.length > 0 ?
                    <React.Fragment>
                      <button
                        onClick={ () => {
                          addConsignmentsClick();
                        }}
                        > Add Consignment
                      </button>

                      <MUIDataTable
                          title={
                            <table>
                              <thead>
                                <tr>
                                  <th colSpan='2'>Customer Consignments Data</th>
                                </tr>
                              </thead>
                              <tbody style={{ textAlign: 'left' }}>

                                {addConsignmentPopup['custClickedDetails'] !== undefined && addConsignmentPopup['custClickedDetails'].length > 0 ?
                                (
                                  <React.Fragment>
                                    <tr>
                                      <td>Customer#:</td>
                                      <td>
                                        {addConsignmentPopup['custClickedDetails'][0]}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td>
                                        {addConsignmentPopup['custClickedDetails'][1]} <br/>
                                        {addConsignmentPopup['custClickedDetails'][2]} <br/>
                                        {addConsignmentPopup['custClickedDetails'][3]} {addConsignmentPopup['custClickedDetails'][3] !== '' ? (<React.Fragment> <br/> </React.Fragment>) : ''}
                                        {addConsignmentPopup['custClickedDetails'][4]} {addConsignmentPopup['custClickedDetails'][5]} {addConsignmentPopup['custClickedDetails'][6]}
                                      </td>
                                    </tr>
                                  </React.Fragment>)

                                : (<React.Fragment></React.Fragment>)
                                }
                              </tbody>
                            </table>
                          }
                          data={consignmentsCustState}
                          columns={columns}
                          options={optionsConsignmentsTbl}
                      />            
                    </React.Fragment>

                  : ''
                : ''
              }
            </div>

            <InventoryCount/>
            <InventoryCountEdit/>
            <InventoryCountReplenish/>

          </div>
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
 return {
    consignmentsProductState: state.consignmentsPostReducer['items_fetchConsignmentsProduct'],
    consignmentsCustState: state.consignmentsPostReducer['items_fetchConsignmentsCustomer'],
    userConsignmentsCustState: state.consignmentsPostReducer['items_fetchUserConsignmentsCustomer'],
    addConsignmentPopup: state.consignmentsPostReducer['items_addConsignmentPopup'],    
    authreducerState: state.authreducer,

    
 }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_ConsignmentsProduct: () => {
      dispatch(fetchConsignmentsProduct());
    },
    fetch_ConsignmentsCustomer: (custnoState, showInventoryOnly, showInventoryCountEdit) => {
        dispatch(fetchConsignmentsCustomer(custnoState, showInventoryOnly, showInventoryCountEdit));
    },
    fetch_UserConsignmentsCustomers: (userid, userCustOnly) => {
      dispatch(fetchUserConsignmentsCustomers(userid, userCustOnly));
    },
    fetch_deleteItemsRow: (rowState, newConsignmentsCustState) => {
      dispatch(fetchDeleteItemsRow(rowState, newConsignmentsCustState));
    },
    fetch_editItemsRow: (rowState, newConsignmentsCustState) => {
      dispatch(fetchEditItemsRow(rowState, newConsignmentsCustState));
    },
    set_AddConsignmentPopup: (rowState) => {
      dispatch(setAddConsignmentPopup(rowState));
    }            

    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageConsignments);